import { render, staticRenderFns } from "./MsjContacto.vue?vue&type=template&id=50114f27&scoped=true&"
import script from "./MsjContacto.vue?vue&type=script&lang=js&"
export * from "./MsjContacto.vue?vue&type=script&lang=js&"
import style0 from "./MsjContacto.vue?vue&type=style&index=0&id=50114f27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50114f27",
  null
  
)

export default component.exports